import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown admin-profile" }
const _hoisted_2 = {
  class: "d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = {
  class: "rounded-circle wh-40 administrator d-flex align-items-center justify-content-center bg-primary text-white fw-bold",
  style: { fontSize: '16px' }
}
const _hoisted_5 = { class: "flex-grow-1 ms-2" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "d-none d-xxl-block" }
const _hoisted_8 = { class: "d-flex align-content-center" }
const _hoisted_9 = { class: "dropdown-menu border-0 bg-white dropdown-menu-end" }
const _hoisted_10 = { class: "d-flex align-items-center info" }
const _hoisted_11 = { class: "flex-shrink-0" }
const _hoisted_12 = {
  class: "rounded-circle wh-30 administrator d-flex align-items-center justify-content-center bg-primary text-white fw-bold",
  style: { fontSize: '14px' }
}
const _hoisted_13 = { class: "flex-grow-1 ms-2" }
const _hoisted_14 = { class: "fw-medium" }
const _hoisted_15 = { class: "fs-12" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminProfile',
  setup(__props) {

const user = computed(() => {
  const stored = localStorage.getItem('user');
  return stored ? JSON.parse(stored) : null;
});

const userName = computed(() => {
  return user.value?.name?.split(' ')[0] || 'User';
});

const userFullName = computed(() => {
  return user.value?.name || 'User';
});

const userRole = computed(() => {
  if (!user.value?.roles || user.value.roles.length === 0) return '';
  return user.value.roles[0].libelle || user.value.roles[0].code || '';
});

const userInitials = computed(() => {
  if (!user.value?.name) return 'U';
  const parts = user.value.name.split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return user.value.name.substring(0, 2).toUpperCase();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(userInitials.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(userName.value), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(userInitials.value), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", _hoisted_14, _toDisplayString(userFullName.value), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(userRole.value), 1)
        ])
      ])
    ])
  ]))
}
}

})